(() => {
  const initialized = new WeakSet();
  const attempts = new WeakMap();

  const buildUpdatesUrl = (path) => {
    const url = new URL(path, window.location.origin);
    const currentParameters = new URLSearchParams(window.location.search);
    const previewThemeId = currentParameters.get('preview_theme_id');
    const editorThemeId = window.Shopify?.designMode ? window.Shopify?.theme?.id : null;
    const activeThemeId = previewThemeId || editorThemeId;

    if (activeThemeId) url.searchParams.set('preview_theme_id', activeThemeId);
    return url.toString();
  };

  const retry = (panel) => {
    const attempt = attempts.get(panel) || 1;
    if (attempt >= 3) return;
    initialized.delete(panel);
    window.setTimeout(() => loadProgress(panel), attempt * 700);
  };

  const loadProgress = async (panel) => {
    if (initialized.has(panel)) return;
    initialized.add(panel);

    const handle = panel.dataset.productHandle;
    const updatesUrl = panel.dataset.updatesUrl;
    if (!handle || !updatesUrl) return;
    attempts.set(panel, (attempts.get(panel) || 0) + 1);

    try {
      const response = await fetch(buildUpdatesUrl(updatesUrl), {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) {
        retry(panel);
        return;
      }

      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const source = Array.from(documentFragment.querySelectorAll('.qq-update[data-product-handle]'))
        .find((card) => card.dataset.productHandle === handle);
      if (!source) {
        retry(panel);
        return;
      }

      const stage = Math.max(0, Math.min(6, Number.parseInt(source.dataset.stage, 10) || 0));
      const status = source.dataset.currentStatus || 'Project update available';
      const sourceDate = source.querySelector('.qq-update__meta time');
      const sourceNote = source.querySelector('.qq-update__note');
      const statusElement = panel.querySelector('[data-project-status]');
      const dateElement = panel.querySelector('[data-project-date]');
      const noteElement = panel.querySelector('[data-project-note]');
      const track = panel.querySelector('[data-project-track]');

      statusElement.textContent = status;
      panel.querySelector('[data-project-timeline]').setAttribute(
        'aria-label',
        `${stage} of 6 project stages completed. Current status: ${status}.`
      );
      track.style.width = `${stage === 0 ? 0 : (stage - 1) * 20}%`;

      panel.querySelectorAll('[data-project-step]').forEach((step) => {
        const stepNumber = Number.parseInt(step.dataset.projectStep, 10);
        const dot = step.querySelector('.qq-project-progress__dot');
        const isDone = stage >= stepNumber;
        const isNext = stage + 1 === stepNumber;
        step.classList.toggle('is-done', isDone);
        step.classList.toggle('is-next', isNext);
        dot.textContent = isDone ? '✓' : String(stepNumber);
      });

      if (sourceDate && sourceDate.textContent.trim()) {
        dateElement.textContent = `Updated ${sourceDate.textContent.trim()}`;
        dateElement.hidden = false;
      }

      if (sourceNote && sourceNote.textContent.trim()) {
        noteElement.innerHTML = sourceNote.innerHTML;
        noteElement.hidden = false;
      }

      panel.hidden = false;
    } catch (error) {
      retry(panel);
    }
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-qq-project-progress]').forEach(loadProgress);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
